import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class PaymentStatusRoute extends Route {
  @service router;

  beforeModel(transition) {
    const paymentId = transition.to.params.payment_id;
    const queryParams = transition.to.queryParams;

    this.router.transitionTo('index', {
      queryParams: {
        ...queryParams,
        payment_id: paymentId,
      },
    });
  }
}
